




















































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ModalImporter from "@/modules/simulator/components/ModalImporter.vue";
import SwxNumberInput from "@/components/SwxNumberInput.vue";
import ChosenConcreteTemperatureReadings from "@/modules/julho_14/views/Visualization/components/ChosenConcreteTemperatureReadings.vue";
import { SOURCE } from "@/modules/julho_14/settings";
import sleep from "@/utils/sleep";
import { Status } from "@/modules/simulator/store";

const { State, Action } = namespace("julho_14/simulator");

@Component({
    components: {
        ModalImporter,
        SwxNumberInput,
        ChosenConcreteTemperatureReadings
    }
})
export default class ReservoirInfoImporter extends Vue {
    public source: number = SOURCE;

    @State
    public readonly status!: Status;

    @Action
    public updateFromReservorInfo;

    public get isRunning() {
        return this.status === Status.running;
    }

    public async importData({ data, callback }) {
        await sleep(1000);
        await this.updateFromReservorInfo(data);

        callback();
    }

    public format(value): string {
        return (this.$refs.swxNumberInput as any).format(value);
    }
}
